import { createSlice } from '@reduxjs/toolkit';
import {
  handleResetFilter,
  handleSetSelectedFilterValue,
  handleSetSelectedItems,
  handleToggleCollapsed,
} from 'store/helpers/filterHelpers';
import { handleApplySettingsFilters } from 'store/content/contentHelpers';
import { storyInitialState } from './storyInitialState';
import { fetchStoriesGeneric } from './actions';

export const storySlice = createSlice({
  name: 'storySlice',
  initialState: storyInitialState,
  reducers: {
    setSelectedFilterValue: (state, action) => {
      handleSetSelectedFilterValue(state, action, storyInitialState.filters);
    },
    setSelectedItems: (state, action) => {
      handleSetSelectedItems(state, action);
    },
    toggleCollapsed: (state, action) => {
      handleToggleCollapsed(state, action);
    },
    resetAllFilters: (state) => {
      state.filters = storyInitialState.filters;
    },
    resetFilter: (state, action) => {
      handleResetFilter(state, action, storyInitialState.filters);
    },
    applyWebsiteSettingsFilters: (state, action) => {
      handleApplySettingsFilters(state, action);
    },
    changeSelectedStoryIndex: (state, action) => {
      const storyIndex = action.payload;
      state.selectedStoryIndex = storyIndex;
      if (storyIndex !== null) state.storyDetailModal = true;
    },
    toggleStoryDetailModalState: (state) => {
      state.storyDetailModal = !state.storyDetailModal;
    },
    setIsStoryLeftOrRightKeyClicked: (state, action) => {
      state.isLeftOrRightKeyClicked = action.payload;
    },
    setSelectedFilter: (state, action) => {
      state.selectedFilter = action.payload;
    },
    toggleSelectedStories: (state, action) => {
      const { isChecked, selectedStoryId } = action.payload;
      if (isChecked) {
        state.selectedStories.push(selectedStoryId);
      } else {
        state.selectedStories = state.selectedStories.filter(
          (storyId) => storyId !== selectedStoryId
        );
      }
    },
    clearSelectedStories: (state) => {
      state.selectedStories = [];
    },
  },
  extraReducers: (builder) => {
    const handlePending = (state, key) => {
      state[key].loading = true;
      state[key].error = null;
    };

    const handleFulfilled = (state, action, key) => {
      const { data, loadMore, total } = action.payload;
      if (loadMore) state[key].data.push(...data);
      else state[key].data = data;
      state[key].total = total;
      state[key].loading = false;
      state[key].error = null;
    };

    const handleRejected = (state, action, key) => {
      state[key].loading = false;
      state[key].error = action.payload;
    };

    builder
      .addCase(fetchStoriesGeneric.pending, (state, action) => {
        const key = action.meta.arg.brandId ? 'brandBaanStories' : 'stories';
        handlePending(state, key);
      })
      .addCase(fetchStoriesGeneric.fulfilled, (state, action) => {
        const key = action.meta.arg.brandId ? 'brandBaanStories' : 'stories';
        handleFulfilled(state, action, key);
      })
      .addCase(fetchStoriesGeneric.rejected, (state, action) => {
        const key = action.meta.arg.brandId ? 'brandBaanStories' : 'stories';
        handleRejected(state, action, key);
      });
  },
});

export const {
  changeSelectedStoryIndex,
  toggleStoryDetailModalState,
  setIsStoryLeftOrRightKeyClicked,
  setSelectedFilterValue,
  toggleCollapsed,
  resetAllFilters,
  applyWebsiteSettingsFilters,
  resetFilter,
  setSelectedItems,
  setSelectedFilter,
  toggleSelectedStories,
  clearSelectedStories,
} = storySlice.actions;
